export const moderateAnswer = (payload?: any) => ({
  type: "@saga/MODERATE_ANSWER",
  payload,
});
